import { render, staticRenderFns } from "./RetailerSettingsAddressModal.vue?vue&type=template&id=f465d47e&lang=pug"
import script from "./RetailerSettingsAddressModal.vue?vue&type=script&lang=js"
export * from "./RetailerSettingsAddressModal.vue?vue&type=script&lang=js"
import style0 from "./RetailerSettingsAddressModal.vue?vue&type=style&index=0&id=f465d47e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports